(() => {
  if (customElements.get('header-countdown-bar')) return;

  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  class HeaderCountdownBar extends HTMLElement {
    #intervalId = null;

    connectedCallback() {
      const endMs = Number(this.dataset.endMs);
      const hideWhenElapsed = this.dataset.hideWhenElapsed === 'true';
      const expiredMessage = this.dataset.expiredMessage || '';
      const alreadyExpired = this.dataset.alreadyExpired === 'true';

      const active = this.querySelector('[data-countdown-active]');
      const expired = this.querySelector('[data-countdown-expired]');
      const unitEls = this.querySelectorAll('[data-countdown-unit]');

      const applyExpired = () => {
        if (this.#intervalId) {
          clearInterval(this.#intervalId);
          this.#intervalId = null;
        }
        if (hideWhenElapsed) {
          this.hidden = true;
          return;
        }
        active?.setAttribute('hidden', '');
        if (expired) {
          expired.removeAttribute('hidden');
          expired.textContent = expiredMessage;
        }
      };

      const tick = () => {
        if (!Number.isFinite(endMs)) {
          applyExpired();
          return;
        }

        const diff = endMs - Date.now();
        if (diff <= 0) {
          applyExpired();
          return;
        }

        const totalSec = Math.floor(diff / 1000);
        const days = Math.floor(totalSec / 86400);
        const hours = Math.floor((totalSec % 86400) / 3600);
        const minutes = Math.floor((totalSec % 3600) / 60);
        const seconds = totalSec % 60;

        const values = [days, hours, minutes, seconds];
        unitEls.forEach((el, i) => {
          if (values[i] !== undefined) el.textContent = pad(values[i]);
        });
      };

      if (alreadyExpired) {
        applyExpired();
        return;
      }

      tick();
      this.#intervalId = window.setInterval(tick, 1000);
    }

    disconnectedCallback() {
      if (this.#intervalId) clearInterval(this.#intervalId);
    }
  }

  customElements.define('header-countdown-bar', HeaderCountdownBar);
})();
